import script from "./InvoicePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePreview.vue?vue&type=script&setup=true&lang=js"

import "./InvoicePreview.vue?vue&type=style&index=0&id=66c8fd85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c8fd85"]])

export default __exports__